module.exports = __webpack_public_path__ + "static/media/galeria-fotos-2-big.d44ce805.png";